import ChipColors from '@/app/arch/enums/ChipColors';

export default [
  {
    value: 'P',
    text: 'Pendente',
    ...ChipColors.warning,
  },
  {
    value: 'R',
    text: 'Retry',
    ...ChipColors.light,
  },
  {
    value: 'C',
    text: 'Cancelado',
    ...ChipColors.danger,
  },
];
